import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

export type DsNoticeType =
  | 'error'
  | 'warning'
  | 'informational'
  | 'success'
  | 'message';

@Component({
  selector: 'lib-ds-notice',
  templateUrl: './notice.component.html',
  styleUrl: './notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsNoticeComponent {
  readonly message = input('');
  /*
  * Types: error, warning, success, message
  * */
  readonly type =
    input<DsNoticeType>('informational');
  readonly hideClose = input(false);

  readonly actionLabel =
    input<string | null>(null);
  readonly actionDisabled = input(false);

  readonly dismiss = output<void>();
  readonly action = output<void>();

  get ariaRole(): 'alert' | 'status' {
    return this.type() === 'error'
      ? 'alert'
      : 'status';
  }

  onDismiss(): void {
    this.dismiss.emit();
  }

  onAction(): void {
    if (!this.actionDisabled()) {
      this.action.emit();
    }
  }
}
